import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams, App, AlertController, ViewController, ModalController } from 'ionic-angular';
import { ProductsProvider } from '../../../../providers/products/products';
import { SettingsProvider } from '../../../../providers/settings/settings';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { OnboardingProvider } from '../../../../providers/onboarding/onboarding';
import { ThankExistingCustomerPage } from '../../../thank-existing-customer/thank-existing-customer';

/**
 * Generated class for the ApplicationAddressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-application-address',
  templateUrl: 'application-address.html',
})
export class ApplicationAddressPage implements OnInit {
  productForm: FormGroup;
  islivetwelemonth: any = 0;
  isAddressAdded: any = false;
  moveindate: any;
  moveoutdate: any;
  productData: any = {}
  addressVarified: boolean = false;
  istermsandcondition: boolean = false;
  istwelvemonthResidence: boolean = false;
  formInvalid: boolean = false;
  addressEditable: boolean = true;
  islivetwelemonthInvalid: boolean = false;
  selectedError: boolean = false;
  characterPattern: any;
  validIn: boolean = false;
  validOut: boolean = false;
  validGreater: boolean = false;
  pCode: any;
  viewed: any = 0;
  maxDate: any = [];
  minDate: any = [];
  todaysDate: any;
  moveInMax: any = [];
  moveInMin: any = [];
  monthDiff: any;
  monthAdd2: any;
  isBusy: boolean = false;

  street_valid: boolean = true;
  add3_valid: boolean = true;

  county_: boolean = false;
  lastDate: any;

  selfAcc: boolean = true;
  joinAcc: any = "1st";
  constructor(public navCtrl: NavController,
    public cdr: ChangeDetectorRef,
    private app: App,
    public productsProvider: ProductsProvider,
    public alertCtrl: AlertController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public settingsProvider: SettingsProvider,
    private fb: FormBuilder,
    private zone: NgZone,
    public onboardingProvider: OnboardingProvider,
    public modalCtrl: ModalController) {
    let self = this;
    if (navParams.get("viewed") != undefined) {
      this.viewed = navParams.get("viewed");
    } else {
      if (self.settingsProvider.settings.productFormData.address == undefined) {
        this.viewed = 0;
      }
      else {
        this.viewed = self.settingsProvider.settings.productFormData.address.length - 1;
      }
    }

    this.lastDate = this.formatDateTimeDate(new Date());

    this.todaysDate = this.formatDateTimeDate(new Date());

    if (self.settingsProvider.settings.accountType === "Self") {
      self.selfAcc = true;
    } else {
      self.selfAcc = false;
      if (!self.settingsProvider.settings.productFormData.firstname) {
        self.joinAcc = "1st";
      } else if (!self.settingsProvider.settings.productFormData2.firstname) {
        self.joinAcc = "2nd";
      }
      // self.joinAcc = self.settingsProvider.settings.productFormData === {} ? "1st":"2nd"; 
    }

    if (self.settingsProvider.settings.productFormData && self.selfAcc) {
      this.productData = self.settingsProvider.settings.productFormData;
      this.maxDate = self.settingsProvider.settings.maxDate;
      this.minDate = self.settingsProvider.settings.minDate;
      this.moveInMax = self.settingsProvider.settings.moveInMax;
    } else if (self.joinAcc === "1st") {
      this.productData = self.settingsProvider.settings.productFormData;
      this.maxDate = self.settingsProvider.settings.maxDate;
      this.minDate = self.settingsProvider.settings.minDate;
      this.moveInMax = self.settingsProvider.settings.moveInMax;
    } else if (self.joinAcc === "2nd") {
      this.productData = self.settingsProvider.settings.productFormData2;
      this.maxDate = self.settingsProvider.settings.maxDate;
      this.minDate = self.settingsProvider.settings.minDate;
      this.moveInMax = self.settingsProvider.settings.moveInMax;
    }
    if (this.maxDate != undefined && this.moveInMax != undefined) {
      if (this.maxDate.length < 0 && this.moveInMax.length < 0) {
        this.maxDate.push(this.todaysDate);
        this.moveInMax.push(this.todaysDate);
      } else {
        this.maxDate[0] = this.todaysDate;
        this.moveInMax[0] = this.todaysDate;
      }
    }
  }

  ionViewDidLoad() {

  }

  ionViewDidEnter() {
    let self = this;
    this.isBusy = false;
    self.settingsProvider.getAppLabels(this.viewCtrl.name);
    if (this.productData.address.length >= 1 && this.productData.address !== undefined) {
      const control = <FormArray>this.productForm.controls.address;

      control.removeAt(0);
      for (let i = 0; i < this.productData.address.length; i++) {
        this.addAddress(i);
      }
    }
  }

  ionViewWillEnter() {
    if (this.settingsProvider.settings.addressEditable) {
      this.yes()
    }
  }

  formatDateTimeDate(date, blockdate = null) {
    if (date !== null && date !== "") {
      var newdate: any = new Date(date);
      let dd: any = newdate.getDate();
      var mm: any = newdate.getMonth() + 1; //January is 0!
      var yyyy = newdate.getFullYear();
      var hh = newdate.getHours();
      var min = newdate.getMinutes().toString().length == 1 ? "0" + newdate.getMinutes().toString() : newdate.getMinutes();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      if (blockdate == null) {
        // newdate = yyyy + '-' + mm + '-' + dd;
        newdate = dd + '-' + mm + '-' + yyyy;

      }
      else {
        newdate = dd + '-' + mm + '-' + yyyy + ' ' + hh + ':' + min;

        // newdate = yyyy + '/' + mm + '/' + dd + ' ' + hh + ':' + min;
      }
      return (newdate)
    }
  }




  ngOnInit() {
    let self = this;
    this.characterPattern = "^[a-zA-Z_ \-]+";
    this.productForm = this.fb.group({
      address: this.fb.array([
        this.addOldAddress()
      ]),
    });
    if (self.settingsProvider.settings.accountType === "Self") {
      self.selfAcc = true;
      // this.dob = this.productData.dob;
    } else {
      self.selfAcc = false;
      if (self.settingsProvider.settings.productFormData.firstname && !self.settingsProvider.settings.productFormData2.firstname) {
        self.joinAcc = "1st";
      } else if (self.settingsProvider.settings.productFormData.firstname && self.settingsProvider.settings.productFormData2.firstname) {
        self.joinAcc = "2nd";
      }
      // self.joinAcc = self.settingsProvider.settings.productFormData === {} ? "1st":"2nd"; 

    }
    if (self.joinAcc === "2nd") {
      this.productForm.reset();
    }
  }

  yes() {
    this.addressVarified = true;
  }

  no() {
    let self = this;
    let status_state = {
      "state_status": "Blocked",
      "product_application_id": this.productData.product_application_id
    }
    self.onboardingProvider.updateProductApplicationStatus(status_state).then((result: any) => {
      if (result.status) {
        let s = this.settingsProvider.settings;
        s.isLoginBlocked = false;
        s.existingCustomer = false;
        s.isApplicationBlocked = true;
        s.status = status_state.state_status;
        self.settingsProvider.setSettings(s).then((data: any) => {
          let message = "Existing customer informed that address is incorrect";
          // self.settingsProvider.loadAudit("newaccount", "product application step 2", "product address application verification", message).catch((err) => {
          //   self.isBusy = false;
          //   self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
          // });
          self.navCtrl.setRoot("LoginBlockedPage");
        }).catch((err) => {
          self.isBusy = false;
          self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
        });
      } else {
        self.app.getRootNavs()[0].setRoot("HomePage", { selectTab: 1 });
        self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
      }
    }).catch((err) => {
      self.isBusy = false;
      self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
    });
  }

  apply() {
    let self = this;

    try {
      if (!self.isBusy) {
        self.isBusy = true;
        for (let add of this.productForm.value.address) {
          if (add.county == "selected" || add.county == null) {
            self.selectedError = true;
          } else {
            self.selectedError = false;
          }
        }


        this.productForm.value.address[0].moveoutdate = this.todaysDate;


        const faControl = (<FormArray>this.productForm.controls['address']).at(0);
        faControl['controls'].moveoutdate.setValue(this.todaysDate);

        if (self.productData.address == undefined) {
          let addressData = {
            add_line1: null,
            add_line2: null,
            add_line3: null,
            city: null,
            county: null,
            islivetwelemonth: 1,
            moveindate: null,
            moveoutdate: null,
            postalcode: null
          }
          addressData.add_line1 = self.productForm.value.address[0].add_line1;
          addressData.add_line2 = self.productForm.value.address[0].add_line2;
          addressData.add_line3 = self.productForm.value.address[0].add_line3;
          addressData.city = self.productForm.value.address[0].city;
          addressData.county = self.productForm.value.address[0].county;
          addressData.postalcode = self.productForm.value.address[0].postalcode;
          addressData.moveindate = self.productForm.value.address[0].moveindate.split("-")[2] + "-" + self.productForm.value.address[0].moveindate.split("-")[1] + "-" + self.productForm.value.address[0].moveindate.split("-")[0];
          addressData.moveoutdate = self.todaysDate;
          let addArry = [];
          const control = <FormArray>self.productForm.controls.address;
          control.removeAt(this.viewed);
          addArry.push(addressData)
          self.productData['address'] = addArry;
          self.addAddress(this.viewed);
        }
        for (let i = 0; i < this.productData.address.length; i++) {
          this.productForm.value.address[i].moveindate = this.productForm.value.address[i].moveindate.split("-")[2] + "-" + this.productForm.value.address[i].moveindate.split("-")[1] + "-" + this.productForm.value.address[i].moveindate.split("-")[0];
          this.productForm.value.address[i].moveoutdate = this.productForm.value.address[i].moveoutdate.split("-")[2] + "-" + this.productForm.value.address[i].moveoutdate.split("-")[1] + "-" + this.productForm.value.address[i].moveoutdate.split("-")[0];

        }
        if (self.productForm.invalid || self.istwelvemonthResidence || self.selectedError || self.validIn || self.validOut || self.validGreater) {
          self.formInvalid = true;
          this.showAlert("Error", "Please fill in all the mandatory fields");
          self.isBusy = false;
        }
        else {
          self.formInvalid = false;
          self.isAddressAdded = false;
          let s = self.settingsProvider.settings;
          console.log("Froduct form 1==>", s.productFormData);
          console.log("Froduct form 2 ==>", s.productFormData2);
          let joinAccount: boolean = true;
          if (s.accountType !== "Self") {
            joinAccount = true;
          } else {
            joinAccount = false;
          }
          console.log("jointAccount ==>", joinAccount);
          console.log("productForm ==>", s.productFormData, s.productFormData2);
          console.log("chk conditions ==>", self.settingsProvider.settings.productFormData.firstname, self.settingsProvider.settings.productFormData2.firstname);
          if (!joinAccount) {
            console.log("not jointaccount")
            if (self.settingsProvider.settings.existingCustomer) {

              // this.formInvalid = false;
              // this.isAddressAdded = false;

              let status_state = {
                "state_status": "Existing Customer Nominated Bank details",
                "product_application_id": self.productData.product_application_id
              }
              self.onboardingProvider.updateProductApplicationStatus(status_state).then((result: any) => {
                if (result.status) {

                  s.maxDate = self.maxDate;
                  s.minDate = self.minDate;
                  s.moveInMax = self.moveInMax;
                  self.productData['address'] = self.productForm.value.address;
                  if (self.selfAcc) {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '1st') {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '2nd') {
                    s.productFormData2 = self.productData;
                  }
                  // s.productFormData = self.productData;
                  self.settingsProvider.setSettings(s).then((data: any) => {
                    let message = "Exsitng customer application for product with product ID 1 accepted";
                    // self.settingsProvider.loadAudit("newaccount", "product application step 2", "product application verification", message).catch((err) => {
                    //   self.isBusy = false;
                    //   self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                    // });
                    self.app.getRootNavs()[0].setRoot("BankDetailsPage")
                  }).catch((err) => {
                    self.isBusy = false;
                    self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                  });
                } else {
                  self.app.getRootNavs()[0].setRoot("HomePage", { selectTab: 1 });
                  self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                }
              }).catch((err) => {
                self.isBusy = false;
                self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
              });
            } else {

              // this.formInvalid = false;
              // this.isAddressAdded = false;

              let approvedProduct = {
                new_accounts_id: self.settingsProvider.settings.newAccountId,
                state_status: "New Customer Nominated Bank Details"
              };

              self.onboardingProvider.changeCustomerStatus(approvedProduct).then((result: any) => {
                if (result.status) {

                  let accounts_data = {
                    mode: 1,
                    new_accounts_id: this.settingsProvider.settings.newAccountId,
                    postalcode: this.productForm.value.address[0].postalcode,
                    add_line1: this.productForm.value.address[0].add_line1,
                    add_line2: this.productForm.value.address[0].add_line2,
                    add_line3: this.productForm.value.address[0].add_line3,
                    city: this.productForm.value.address[0].city,
                    county: this.productForm.value.address[0].county,
                    moveindate: this.productForm.value.address[0].moveindate.split("-")[0].length > 2 ? this.productForm.value.address[0].moveindate : this.productForm.value.address[0].moveindate.split("-")[2] + "-" + this.productForm.value.address[0].moveindate.split("-")[1] + "-" + this.productForm.value.address[0].moveindate.split("-")[0],
                    moveoutdate: this.productForm.value.address[0].moveoutdate.split("-")[0].length > 2 ? this.productForm.value.address[0].moveoutdate : this.productForm.value.address[0].moveoutdate.split("-")[2] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[1] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[0],
                    account_holder_type: self.settingsProvider.settings.accountType === "Self" ? 1 : 2

                    // moveindate: this.productForm.value.address[0].moveindate.split("-")[2] + "-" + this.productForm.value.address[0].moveindate.split("-")[1] + "-" + this.productForm.value.address[0].moveindate.split("-")[0],
                    // moveoutdate: this.productForm.value.address[0].moveoutdate.split("-")[2] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[1] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[0],

                  }


                  self.settingsProvider.updateaccountsdata(accounts_data);
                  let s = self.settingsProvider.settings;
                  s.status = result.state_status;
                  s.maxDate = self.maxDate;
                  s.minDate = self.minDate;
                  s.moveInMax = self.moveInMax;
                  self.productData['address'] = self.productForm.value.address;
                  // s.productFormData = self.productData;
                  if (self.selfAcc) {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '1st') {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '2nd') {
                    s.productFormData2 = self.productData;
                  }
                  self.settingsProvider.setSettings(s).then((data: any) => {
                    let message = "New customer entered address details";
                    // self.settingsProvider.loadAudit("newaccount", "product application step 2", "product application verification", message).catch((err) => {
                    //   self.isBusy = false;
                    //   self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                    // });
                    self.navCtrl.setRoot("BankDetailsPage");
                  }).catch((err) => {
                    self.isBusy = false;
                    self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                  });
                }
              }).catch((err) => {
                self.isBusy = false;

                self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
              });
            }
          } else if (self.settingsProvider.settings.productFormData.firstname && self.settingsProvider.settings.productFormData2.firstname) {
            if (self.settingsProvider.settings.existingCustomer) {

              let status_state = {
                "state_status": "Existing Customer Nominated Bank details",
                "product_application_id": self.productData.product_application_id
              }
              self.onboardingProvider.updateProductApplicationStatus(status_state).then((result: any) => {
                if (result.status) {

                  s.maxDate = self.maxDate;
                  s.minDate = self.minDate;
                  s.moveInMax = self.moveInMax;
                  self.productData['address'] = self.productForm.value.address;
                  // s.productFormData = self.productData;
                  if (self.selfAcc) {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '1st') {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '2nd') {
                    s.productFormData2 = self.productData;
                  }
                  self.settingsProvider.setSettings(s).then((data: any) => {
                    let message = "Exsitng customer application for product with product ID 1 accepted";
                    // self.settingsProvider.loadAudit("newaccount", "product application step 2", "product application verification", message).catch((err) => {
                    //   self.isBusy = false;
                    //   self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                    // });
                    self.app.getRootNavs()[0].setRoot("BankDetailsPage")
                  }).catch((err) => {
                    self.isBusy = false;
                    self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                  });
                } else {
                  self.app.getRootNavs()[0].setRoot("HomePage", { selectTab: 1 });
                  self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                }
              }).catch((err) => {
                self.isBusy = false;
                self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
              });
            } else {

              let approvedProduct = {
                new_accounts_id: self.settingsProvider.settings.newAccountId,
                state_status: "New Customer Nominated Bank Details"
              };
              let account_holder_type = 1
              if (self.settingsProvider.settings.accountType === "Self") {
                account_holder_type = 1
              } else if (self.joinAcc === '1st') {
                account_holder_type = 1
              } else if (self.joinAcc === '2nd') {
                account_holder_type = 2
              }

              self.onboardingProvider.changeCustomerStatus(approvedProduct).then((result: any) => {
                if (result.status) {

                  let accounts_data = {
                    mode: 1,
                    new_accounts_id: this.settingsProvider.settings.newAccountId,
                    postalcode: this.productForm.value.address[0].postalcode,
                    add_line1: this.productForm.value.address[0].add_line1,
                    add_line2: this.productForm.value.address[0].add_line2,
                    add_line3: this.productForm.value.address[0].add_line3,
                    city: this.productForm.value.address[0].city,
                    county: this.productForm.value.address[0].county,
                    moveindate: this.productForm.value.address[0].moveindate.split("-")[0].length > 2 ? this.productForm.value.address[0].moveindate : this.productForm.value.address[0].moveindate.split("-")[2] + "-" + this.productForm.value.address[0].moveindate.split("-")[1] + "-" + this.productForm.value.address[0].moveindate.split("-")[0],
                    moveoutdate: this.productForm.value.address[0].moveoutdate.split("-")[0].length > 2 ? this.productForm.value.address[0].moveoutdate : this.productForm.value.address[0].moveoutdate.split("-")[2] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[1] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[0],
                    account_holder_type: account_holder_type

                    // moveindate: this.productForm.value.address[0].moveindate.split("-")[2] + "-" + this.productForm.value.address[0].moveindate.split("-")[1] + "-" + this.productForm.value.address[0].moveindate.split("-")[0],
                    // moveoutdate: this.productForm.value.address[0].moveoutdate.split("-")[2] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[1] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[0],

                  }


                  self.settingsProvider.updateaccountsdata(accounts_data);
                  let s = self.settingsProvider.settings;
                  s.status = result.state_status;
                  s.maxDate = self.maxDate;
                  s.minDate = self.minDate;
                  s.moveInMax = self.moveInMax;
                  self.productData['address'] = self.productForm.value.address;
                  // s.productFormData = self.productData;
                  if (self.selfAcc) {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '1st') {
                    s.productFormData = self.productData;
                  } else if (!self.selfAcc && self.joinAcc === '2nd') {
                    s.productFormData2 = self.productData;
                  }
                  self.settingsProvider.setSettings(s).then((data: any) => {
                    let message = "New customer entered address details";
                    // self.settingsProvider.loadAudit("newaccount", "product application step 2", "product application verification", message).catch((err) => {
                    //   self.isBusy = false;
                    //   self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                    // });
                    self.navCtrl.setRoot("BankDetailsPage");
                  }).catch((err) => {
                    self.isBusy = false;
                    self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                  });
                }
              }).catch((err) => {
                self.isBusy = false;

                self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
              });
            }
          } else {
            let approvedProduct = {
              new_accounts_id: self.settingsProvider.settings.newAccountId,
              state_status: "New Customer 2nd Bank Holder Personal Details"
            };
            let account_holder_type = 1
            if (self.settingsProvider.settings.accountType === "Self") {
              account_holder_type = 1
            } else if (self.joinAcc === '1st') {
              account_holder_type = 1
            } else if (self.joinAcc === '2nd') {
              account_holder_type = 2
            }

            self.onboardingProvider.changeCustomerStatus(approvedProduct).then((result: any) => {
              if (result.status) {

                let accounts_data = {
                  mode: 1,
                  new_accounts_id: this.settingsProvider.settings.newAccountId,
                  postalcode: this.productForm.value.address[0].postalcode,
                  add_line1: this.productForm.value.address[0].add_line1,
                  add_line2: this.productForm.value.address[0].add_line2,
                  add_line3: this.productForm.value.address[0].add_line3,
                  city: this.productForm.value.address[0].city,
                  county: this.productForm.value.address[0].county,
                  moveindate: this.productForm.value.address[0].moveindate.split("-")[0].length > 2 ? this.productForm.value.address[0].moveindate : this.productForm.value.address[0].moveindate.split("-")[2] + "-" + this.productForm.value.address[0].moveindate.split("-")[1] + "-" + this.productForm.value.address[0].moveindate.split("-")[0],
                  moveoutdate: this.productForm.value.address[0].moveoutdate.split("-")[0].length > 2 ? this.productForm.value.address[0].moveoutdate : this.productForm.value.address[0].moveoutdate.split("-")[2] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[1] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[0],
                  account_holder_type: account_holder_type

                  // moveindate: this.productForm.value.address[0].moveindate.split("-")[2] + "-" + this.productForm.value.address[0].moveindate.split("-")[1] + "-" + this.productForm.value.address[0].moveindate.split("-")[0],
                  // moveoutdate: this.productForm.value.address[0].moveoutdate.split("-")[2] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[1] + "-" + this.productForm.value.address[0].moveoutdate.split("-")[0],

                }


                self.settingsProvider.updateaccountsdata(accounts_data);
                let s = self.settingsProvider.settings;
                s.status = result.state_status;
                s.maxDate = self.maxDate;
                s.minDate = self.minDate;
                s.moveInMax = self.moveInMax;
                self.productData['address'] = self.productForm.value.address;
                // s.productFormData = self.productData;
                if (self.selfAcc) {
                  s.productFormData = self.productData;
                } else if (!self.selfAcc && self.joinAcc === '1st') {
                  s.productFormData = self.productData;
                } else if (!self.selfAcc && self.joinAcc === '2nd') {
                  s.productFormData2 = self.productData;
                }
                self.settingsProvider.setSettings(s).then((data: any) => {
                  let message = "New Customer 2nd Bank Holder Personal Details";
                  // self.settingsProvider.loadAudit("newaccount", "product application step 2", "product application verification", message).catch((err) => {
                  //   self.isBusy = false;
                  //   self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                  // });
                  self.navCtrl.setRoot("ProductFormPage");
                }).catch((err) => {
                  self.isBusy = false;
                  self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
                });
              }
            }).catch((err) => {
              self.isBusy = false;

              self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
            });
          }
        }
      }
    } catch (err) {
      self.isBusy = false;

    }


  }

  setAddressifnotselected() {
    if (!this.county_) {
      let addArry = [];
      let addressData = {
        add_line1: this.productForm.value.address[0].add_line1,
        add_line2: this.productForm.value.address[0].add_line2,
        add_line3: this.productForm.value.address[0].add_line3,
        city: this.productForm.value.address[0].city,
        county: this.productForm.value.address[0].county,
        islivetwelemonth: 1,
        moveindate: this.productForm.value.address[0].moveindate,
        moveoutdate: null,
        postalcode: this.productForm.value.address[0].postalcode
      }
      const control = <FormArray>this.productForm.controls.address;
      if (this.productData.address == undefined) {
        //control.removeAt(this.viewed);
        addArry.push(addressData)
        this.productData['address'] = addArry;
      }
    }
    this.addAddress();
  }

  addAddress(i = null): void {
    if (this.istwelvemonthResidence && this.productForm.value.address.length - 1 == this.viewed) {
      this.add3_valid = true;
      this.street_valid = true;
    }
    const control = <FormArray>this.productForm.controls.address;
    control.push(this.addOldAddress(i));
    this.istwelvemonthResidence = false;
    if (i == null) {
      this.viewed += 1;
    }
  }

  deleteAddress(i: number): void {
    const control = <FormArray>this.productForm.controls.address;
    control.removeAt(i);
    if (i != null) {
      this.viewed -= 1;
    }
    if (i > 0) {
      this.maxDate.splice(i + 1, 1);
      this.moveInMax.splice(i + 1, 1);
      this.moveInMin.splice(i - 1, 1);
      this.minDate.splice(i - 1, 1);
    }
    this.totalMounth(i - 1);
  }

  deleteArray() {
    let control = <FormArray>this.productForm.controls.address;
    while (control.length !== 1) {
      control.removeAt(control.length - 1)
    }
  }

  addOldAddress(pos = null): FormGroup {
    let _characterPattern = /^[-@.\/#&+\w\s]*$/;
    let alpaNumeric = "^[a-zA-Z0-9_ ]*$";
    let datePattern = "^(0[1-9]|1[0-9]|2[0-9]|3[01])-(0[1-9]|1[012])-[0-9]{4}$"
    let ddmmyyyyrgexp = /(^(((0[1-9]|1[0-9]|2[0-8])[-](0[1-9]|1[012]))|((29|30|31)[-](0[13578]|1[02]))|((29|30)[-](0[4,6,9]|11)))[-](19|[2-9][0-9])\d\d$)|(^29[-]02[-](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;

    if (pos != null) {
      let m_movindate = ""; let m_moveoutdate = "";
      if (this.productData.address && this.productData.address[pos].moveindate) {
        m_movindate = this.productData.address[pos].moveindate.split("-")[0].length > 2 ? this.productData.address[pos].moveindate.split("-")[2] + "-" + this.productData.address[pos].moveindate.split("-")[1] + "-" + this.productData.address[pos].moveindate.split("-")[0] : this.productData.address[pos].moveindate;
      }
      if (this.productData.address && this.productData.address[pos].moveoutdate) {
        m_moveoutdate = this.productData.address[pos].moveoutdate.split("-")[0].length > 2 ? this.productData.address[pos].moveoutdate.split("-")[2] + "-" + this.productData.address[pos].moveoutdate.split("-")[1] + "-" + this.productData.address[pos].moveoutdate.split("-")[0] : this.productData.address[pos].moveoutdate;
      }



      this.moveindate = this.productData.address[pos].moveindate,
        this.moveoutdate = this.productData.address[pos].moveoutdate

      return this.fb.group({
        city: [this.productData.address[pos].city, [Validators.required]],
        postalcode: [this.productData.address[pos].postalcode, [Validators.required, Validators.maxLength(10), Validators.pattern(alpaNumeric)]],
        add_line1: [this.productData.address[pos].add_line1, [Validators.required, Validators.maxLength(40), Validators.pattern(_characterPattern)]],
        add_line2: [this.productData.address[pos].add_line2, [Validators.maxLength(40), Validators.pattern(_characterPattern)]],
        add_line3: [this.productData.address[pos].add_line3, [Validators.maxLength(40), Validators.pattern(_characterPattern)]],
        county: [this.productData.address[pos].county, [Validators.required]],
        moveindate: [m_movindate, [Validators.required, Validators.maxLength(10), Validators.pattern(datePattern)]],
        moveoutdate: [m_moveoutdate, [Validators.required, Validators.maxLength(10), Validators.pattern(datePattern)]],
        islivetwelemonth: [1]
      });


    } else {
      // return this.fb.group({
      //   city: [this.productData.city, [Validators.required]],
      //   postalcode: [this.productData.postalcode, [Validators.required, Validators.maxLength(15), Validators.pattern(alpaNumeric)]],
      //   street: [this.productData.street, [Validators.required, Validators.maxLength(40), Validators.pattern(_characterPattern)]],
      //   houseno: [this.productData.houseno, [Validators.required, Validators.maxLength(40), Validators.pattern(_characterPattern)]],
      //   add3: [this.productData.add3, [Validators.required]],
      //   moveindate: [this.productData.moveindate],
      //   moveoutdate: [this.productData.moveindate],
      //   islivetwelemonth: [1]
      // });
      this.moveindate = this.productData.moveindate,
        this.moveoutdate = this.productData.moveoutdate

      let m_movindate = ""; let m_moveoutdate = "";
      if (this.productData.address && this.productData.address.moveindate) {
        m_movindate = this.productData.address.moveindate.split("-")[0].length > 2 ? this.productData.address.moveindate.split("-")[2] + "-" + this.productData.address.moveindate.split("-")[1] + "-" + this.productData.address.moveindate.split("-")[0] : this.productData.address.moveindate;
      }
      if (this.productData.address && this.productData.address.moveoutdate) {
        let m_moveoutdate = this.productData.address.moveoutdate.split("-")[0].length > 2 ? this.productData.address.moveoutdate.split("-")[2] + "-" + this.productData.address.moveoutdate.split("-")[1] + "-" + this.productData.address.moveoutdate.split("-")[0] : this.productData.address.moveoutdate;
      }

      return this.fb.group({
        city: [this.productData.city, [Validators.required]],
        postalcode: [this.productData.postalcode, [Validators.required, Validators.maxLength(15), Validators.pattern(alpaNumeric)]],
        add_line1: [this.productData.add_line1, [Validators.required, Validators.maxLength(40), Validators.pattern(_characterPattern)]],
        add_line2: [this.productData.add_line2, [Validators.maxLength(40), Validators.pattern(_characterPattern)]],
        add_line3: [this.productData.add_line3, [Validators.maxLength(40), Validators.pattern(_characterPattern)]],
        county: [this.productData.county, [Validators.required]],
        moveindate: [m_movindate, [Validators.maxLength(40), Validators.pattern(datePattern)]],
        moveoutdate: [m_moveoutdate, [Validators.maxLength(40), Validators.pattern(datePattern)]],
        islivetwelemonth: [1]
      });
    }

  }


  validateDateInput(dob) {
    let charac_reg = /^[0-9-]*$/;
    let rgexp = /(^(((0[1-9]|1[0-9]|2[0-8])[-](0[1-9]|1[012]))|((29|30|31)[-](0[13578]|1[02]))|((29|30)[-](0[4,6,9]|11)))[-](19|[2-9][0-9])\d\d$)|(^29[-]02[-](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
    if (dob.length < 10) {
      if (charac_reg.test(dob)) {
        if (dob.length == 2) {
          if (parseInt(dob) <= 31) {
            dob = dob + "-";
          }
          else {
            dob = "";

          }
        }
        else if (dob.length == 5) {
          if (parseInt(dob.split("-")[1]) <= 12) {
            dob = dob + "-";

          }
          else {
            dob = dob.substring(0, dob.length - 2)
              ("dob:", dob)
          }
        }
      }
      else {
        dob = dob.substring(0, dob.length - 1)
      }
    }
    else {
      if (!rgexp.test(dob)) {
        return dob;
      }
    }

    return dob;
  }

  convertDate(date) {

    let e: any = {};
    var res = date.split("-");
    e.year = res[2];
    e.month = res[1];
    e.day = res[0];

    return e.year + '-' + e.month + '-' + e.day;

  }

  checkLivingDate(i = null, status = null, s) {
    //new code

    // let s = e.detail.value;
    // (s, s.length);
    // if (s.length == 10) {
    let indexMax;
    // let _characterPattern = /^[-@.\/#&+\w\s]*$/;
    // let alpaNumeric = "^[a-zA-Z0-9_ ]*$";
    // let datePattern = "^(0[1-9]|1[0-9]|2[0-9]|3[01])-(0[1-9]|1[012])-[0-9]{4}$"
    // let ddmmyyyyrgexp = /(^(((0[1-9]|1[0-9]|2[0-8])[-](0[1-9]|1[012]))|((29|30|31)[-](0[13578]|1[02]))|((29|30)[-](0[4,6,9]|11)))[-](19|[2-9][0-9])\d\d$)|(^29[-]02[-](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
    let e: any = {};
    var res = s.split("-");
    e.year = parseInt(res[2]);
    e.month = parseInt(res[1]);
    e.day = parseInt(res[0]);

    //   // new code end

    // if (this.productForm.value.address[0].moveindate.length < 10) {
    //   let returnval = "moveindate" + i;
    //   this.productForm = this.fb.group({
    //     address: this.fb.array([
    //       {
    //         city: [this.productData.address[i].city, [Validators.required]],
    //         postalcode: [this.productData.address[i].postalcode, [Validators.required, Validators.maxLength(10), Validators.pattern(alpaNumeric)]],
    //         add_line1: [this.productData.address[i].add_line1, [Validators.required, Validators.maxLength(40), Validators.pattern(_characterPattern)]],
    //         add_line2: [this.productData.address[i].add_line2, [Validators.maxLength(40), Validators.pattern(_characterPattern)]],
    //         add_line3: [this.productData.address[i].add_line3, [Validators.maxLength(40), Validators.pattern(_characterPattern)]],
    //         county: [this.productData.address[i].county, [Validators.required]],
    //         moveindate: [this.validateDateInput(e.value), [Validators.required, Validators.maxLength(10), Validators.pattern(ddmmyyyyrgexp)]]
    //       }
    //     ]),
    //   })
    //   // this.productForm.value.address[0].moveindate = this.validateDateInput(e.value);
    //   if (!this.cdr['destroyed']) {
    //     this.cdr.detectChanges();
    //   }
    // }
    // else {

    // let news = new Date();
    // let old = new Date(this.productForm.value.address[0].moveindate);
    let moveindate = this.convertDate(this.productForm.value.address[i].moveindate);

    // let odd = new Date(moveindate)

    if (i >= 1) {
      if (this.productForm.value.address[i].moveoutdate !== null) {
        let moveoutdate = this.convertDate(this.productForm.value.address[i].moveoutdate);

        if (new Date() <= new Date(moveoutdate)) {
          if (status == "out") {
            this.validOut = true;
            this.settingsProvider.showWarning("", "The Move out date you have selected is greater than todays date. Please re-enter and try again.")
          } else {
            this.validOut = false;
          }

        }
      }
    }

    if (i >= 0) {
      if (new Date() <= new Date(moveindate)) {
        if (status == "in") {
          this.validIn = true;

          this.productForm.value.address[i].moveindate = ""; e.day = null; e.month = null; e.year = null;
          this.settingsProvider.showWarning("", "The Move in date you have selected is greater than todays date. Please re-enter and try again.")
        } else {
          this.validIn = false;

        }
      }
    }
    if (this.todaysDate == this.maxDate[0]) {
      indexMax = i
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    } else {
      indexMax = this.maxDate.indexOf(this.maxDate[i]);
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    }
    let indexMin = this.minDate.indexOf(this.minDate[i - 1]);
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }

    if (indexMax == i) {
      this.maxDate[i + 1] = this.productForm.value.address[i].moveindate;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    } else {
      this.maxDate.push(this.productForm.value.address[i].moveindate);
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    }

    if (i == 0 && status == "in" || i < this.moveInMax.length) {
      this.moveInMax[i + 1] = this.productForm.value.address[i].moveindate;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    }

    if (this.moveInMin[i - 1] != undefined && status == "out") {
      this.moveInMin[i - 1] = this.productForm.value.address[i].moveoutdate;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    } else {
      if (this.productForm.value.address.length >= 2 && status == "out") {
        this.moveInMin.push(this.productForm.value.address[i].moveoutdate);
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
      }
    }
    if (this.productForm.value.address.length >= 2 && status == "out") {
      this.moveInMax[i] = this.productForm.value.address[i].moveoutdate;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    } else {
      if (this.moveInMax[i + 1] == undefined) {
        this.moveInMax.push(this.productForm.value.address[i].moveindate);
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
      }
    }

    if (this.productForm.value.address.length >= 1 && status == "out") {
      this.minDate[i - 1] = this.productForm.value.address[i].moveindate;
      let moveoutdate = this.convertDate(this.productForm.value.address[i].moveoutdate);
      let minimun = this.convertDate(this.minDate[i - 1]);
      // this.productForm.value.address[i].moveoutdate
      if (new Date(moveoutdate) < new Date(minimun)) {
        this.settingsProvider.showWarning("", "The move out date should be gretaer than move in date")
        this.validGreater = true
        this.productForm.value.address[i].moveoutdate = '';
      } else {
        this.validGreater = false

      }
    }

    if (this.productForm.value.address.length >= 2 && status == "in" && i != 0) {
      if (indexMin == i - 1) {

        this.minDate[i - 1] = this.productForm.value.address[i].moveindate;
        // let moveoutdate = this.convertDate(this.productForm.value.address[i].moveoutdate);
        // let minimun = this.convertDate(this.minDate[i - 1]);
        // if(new Date(moveoutdate) < new Date(minimun)) {
        //   this.settingsProvider.showWarning("","The move out date should be gretaer than move in date")

        // }
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
      } else {
        this.minDate.push(this.productForm.value.address[i].moveindate);
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
      }
    }
    this.productForm.value.address[0].moveoutdate = this.todaysDate;

    this.totalMounth(i);
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
    // }

    // }
  }

  totalMounth(i) {
    // this.productForm.value.address[0].moveoutdate = this.convertDate(new Date());

    if (this.productForm.value.address[i].moveindate != null && this.productForm.value.address[i].moveoutdate != null) {
      this.monthDiff = null;
      for (let d = 0; d < this.productForm.value.address.length; d++) {
        let indate = this.convertDate(this.productForm.value.address[d].moveindate);
        let outDate = this.convertDate(this.productForm.value.address[d].moveoutdate);
        let dt1 = new Date(indate);
        let dt3 = new Date(outDate);
        let diff2 = (dt1.getTime() - dt3.getTime()) / 1000;
        diff2 /= (60 * 60 * 24 * 7 * 4);
        this.monthAdd2 = Math.abs(Math.round(diff2));
        this.monthDiff += this.monthAdd2;
        if (this.monthDiff < 12) {
          this.istwelvemonthResidence = true;
        } else {
          this.istwelvemonthResidence = false;
          const control = <FormArray>this.productForm.controls.address;
          control.removeAt(i + 1);
        }
      }
    }

  }

  next() {
    this.viewed += 1;

  }

  wrongDetails() {
    this.navCtrl.setRoot("WrongDetailsInfoPage");
  }

  /**
   * Restart Registration
   */
  restart() {
    let self = this;
    if (this.viewed > 0) {
      this.viewed -= 1;
    }
    else if (this.settingsProvider.settings.existingCustomer) {
      let s = self.settingsProvider.settings;
      let status_state = {
        "state_status": "Existing Customer Personal Details",
        "product_application_id": s.product_application_id
      }
      self.onboardingProvider.updateProductApplicationStatus(status_state).then((result: any) => {
        if (result.status) {
          this.navCtrl.setRoot("ProductFormPage");
        } else {
          self.app.getRootNavs()[0].setRoot("HomePage", { selectTab: 1 });
          self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
        }
      }).catch((err) => {
        self.isBusy = false;
        self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
      });
    } else {
      self.settingsProvider.updateStatus("New Customer Personal Details").catch((err) => {
        self.isBusy = false;
        self.settingsProvider.commonAlertCtrl("Alert", "Sorry, some error occurred Please try again.", "Ok")
      });
    }
  }

  /**
    * Common alertcontroller
    */
  commonAlertCtrl(message) {
    let self = this;
    let alert = self.alertCtrl.create({
      title: self.settingsProvider.getLabel("Success"),
      message: self.settingsProvider.getLabel(message),
      buttons: [
        {
          text: self.settingsProvider.getLabel("Ok"),
          role: 'Ok',
          handler: () => {
          }
        },
      ]
    });
    alert.present();
  }

  /**
   * Check Existing mobile no
   */
  checkExistingMobileNo() {
    let self = this;
    let checkData = {
      mobileno: self.productForm.value.mobileno,
      mobileno2: self.productForm.value.mobileno2
    };
    self.onboardingProvider.checkExistingMobileNo(checkData).then((result: any) => {
      if (!result.status) {
        self.commonAlertCtrl(result.message);
      }
    }).catch((error) => {
    });
  }

  showAlert(title, msg) {
    let self = this;
    let alert = self.alertCtrl.create({
      title: self.settingsProvider.getLabel(title),
      message: self.settingsProvider.getLabel(msg),
      buttons: [
        {
          text: self.settingsProvider.getLabel('OK'),
          role: 'cancel',
          handler: () => {
            self.isBusy = false;
          }
        }
      ]
    });
    alert.present();
  }


  /**
  * Check Existing mobile no
  */
  checkExistingEmail() {
    let self = this;
    let checkData = {
      emailid: self.productForm.value.emailid
    };
    self.onboardingProvider.checkExistingEmail(checkData).then((result: any) => {
      if (!result.status) {
        self.commonAlertCtrl(result.message);
      }
    }).catch((error) => {
    });
  }

  getAddress() {
    let self = this;
    if (!this.isBusy) {
      self.pCode = {
        "postalCode": self.productForm.value.address[self.viewed].postalcode.split(" ").join("").toLowerCase()
      };

      if (this.pCode != null && this.pCode.postalCode.trim() != "") {
        this.settingsProvider.showLoading();
        this.isBusy = true;
        this.onboardingProvider.getAddress(this.pCode).then((result: any) => {
          if (result.count > 0) {
            this.addAction(result.data);
          }
          else {
            this.isBusy = false;
            this.settingsProvider.hideLoading();
            this.commonAlertBox("Unknown Post Code", "We were unable to find your post code. Please complete your address details below.", "Ok")
          }
        }).catch((err) => {
          this.isBusy = false;
          this.settingsProvider.hideLoading();
          this.commonAlertBox("Alert", "Sorry, something went wrong.", "Ok")
          //this.onboardingProvider.postalcode_api_fail().then(() => { }).catch(() => { })

        })
        // if (this.settingsProvider.settings.rules_engine != null) {
        //   let postcode_arr = this.settingsProvider.settings.rules_engine.postrestriction.split(",")
        //   let find_match = postcode_arr.filter((x) => x.trim().toLowerCase() == this.pCode.trim().substring(0, this.pCode.trim().length - 3).toLowerCase());
        //   if (find_match.length > 0) {
        //     this.settingsProvider.commonAlertCtrl("Alert", "Sorry, the product you applied for is not available for selected postalcode.", "Ok")
        //     this.isBusy = false;
        //     this.productForm.value.address[this.viewed].postalcode = "";
        //   }
        //   else {
        //     this.settingsProvider.showLoading();
        //     this.onboardingProvider.getAddress(this.pCode).then((result: any) => {
        //       if (result.count > 0 && result.results.id != "") {
        //         this.addAction(result.results);
        //       }
        //       else {
        //         this.isBusy = false;
        //         this.settingsProvider.hideLoading();
        //         this.commonAlertBox("Alert", "Sorry, address not found.", "Ok")
        //       }
        //     }).catch((err) => {
        //       this.isBusy = false;
        //       this.commonAlertBox("Alert", "Sorry, something went wrong.", "Ok")
        //       this.onboardingProvider.postalcode_api_fail().then(() => { }).catch(() => { })
        //       
        //     })
        //   }
        // }
        // else {
        //   this.settingsProvider.showLoading();
        //   this.onboardingProvider.getAddress(this.pCode).then((result: any) => {
        //     if (result.count > 0 && result.results.id != "") {
        //       this.addAction(result.results);
        //     }
        //     else {
        //       this.isBusy = false;
        //       this.settingsProvider.hideLoading();
        //       this.commonAlertBox("Alert", "Sorry, address not found.", "Ok")
        //     }
        //   }).catch((err) => {
        //     this.isBusy = false;
        //     this.commonAlertBox("Alert", "Sorry, something went wrong.", "Ok")
        //     this.onboardingProvider.postalcode_api_fail().then(() => { }).catch(() => { })
        //     
        //   })
        // }
      }
      else {
        this.commonAlertBox("Alert", "Please enter postcode.", "Ok")
      }
    }
  }

  commonAlertBox(title, message, action) {
    let self = this;
    let alert = self.alertCtrl.create({
      title: self.settingsProvider.getLabel(title),
      message: self.settingsProvider.getLabel(message),
      buttons: [
        {
          text: self.settingsProvider.getLabel("Ok"),
          role: 'Ok',
          handler: () => {
            self.isBusy = false;
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  addAction(data) {
    let self = this;
    this.settingsProvider.hideLoading();
    let modal = this.modalCtrl.create(AddActionModal, { address: data });
    let addressData = {
      add_line1: null,
      add_line2: null,
      add_line3: null,
      city: null,
      county: null,
      islivetwelemonth: 1,
      moveindate: null,
      moveoutdate: null,
      postalcode: null
    }
    let addArry = [];
    modal.onDidDismiss((data) => {
      this.isBusy = false;
      if (data.id != "") {
        let body = {
          "addressId": data.id
        }
        this.onboardingProvider.get_addressLines(body).then((result: any) => {

          if (result.data.length > 0) {
            addressData.add_line1 = result.data[0].content;
            addressData.add_line2 = result.data[1].content;
            addressData.add_line3 = result.data[2].content;
            addressData.city = result.data[3].content;
            addressData.county = result.data[4].content;
            addressData.postalcode = result.data[5].content;

            if (addressData.add_line2 == "") {
              self.street_valid = false;
            } else {
              self.street_valid = true;
            }

            if (addressData.add_line3 == "") {
              self.add3_valid = false;
            } else {
              self.add3_valid = true;
            }

            if (addressData.county != "" && addressData.county != undefined) {
              self.county_ = true;
            } else {
              self.county_ = false;
            }
            const control = <FormArray>this.productForm.controls.address;
            if (this.productData.address == undefined) {
              control.removeAt(this.viewed);
              addArry.push(addressData)
              this.productData['address'] = addArry;
              this.addAddress(this.viewed);
            }
            else {
              if (this.productData.address[this.viewed] != undefined) {
                this.productData.address[this.viewed] = addressData;
                while (control.length !== 0) {
                  control.removeAt(control.length - 1)
                }
                for (let i = 0; i < this.productData.address.length; i++) {
                  this.addAddress(i);
                }
              } else {
                control.removeAt(this.viewed);
                this.productData.address.push(addressData);
                this.addAddress(this.viewed);
              }
            }
          }
        }).catch((err) => {
          self.add3_valid = true;
          self.street_valid = true;
          self.settingsProvider.showWarning("", "Sorry postcode lookup service encountered an error. Please enter address manually.")
        });
      }
    });
    modal.present();

  }

  onKeyUp() {
    let self = this;
    self.county_ = false;
  }

  checkstreetname(e) {

    if (e.value.split(" ").length == 2) {
      e.value = e.value.split(" ")[0].charAt(0).toUpperCase() + e.value.split(" ")[0].slice(1) + " " + e.value.split(" ")[1].charAt(0).toUpperCase() + e.value.split(" ")[1].slice(1)
    }
  }

  updateaccountsdata(data) {
    this.settingsProvider.updateaccountsdata(data).then(
      (res: any) => {

      }
    ).catch((err: any) => {

    });
  }
  //check add3 avalibe or not
  checkadd3() {

  }

  onFormat(event, index, status) {
    // let moveindate = 'moveindate' + i
    // var input = document.getElementById(moveindate) as HTMLInputElement;
    let self = this;


    const input = event.target as HTMLInputElement;
    // let self = this;
    let trimmed = input.value.replace(/\s+/g, '');


    if (trimmed.length > 10) {
      trimmed = trimmed.substr(0, 10);
    }

    if (trimmed.length == 10) {
      self.checkLivingDate(index, status, trimmed)
    }


    trimmed = trimmed.replace(/-/g, '');

    let numbers = [];
    numbers.push(trimmed.substr(0, 2));
    if (trimmed.substr(2, 2) !== "")
      numbers.push(trimmed.substr(2, 2));
    if (trimmed.substr(4, 4) != "")
      numbers.push(trimmed.substr(4, 4));
    input.value = numbers.join('-');

    const myForm = (<FormArray>self.productForm.get("address")).at(index);



    if (status == 'in') {
      myForm.patchValue({
        moveindate: input.value
      });

    } else {
      myForm.patchValue({
        moveoutdate: input.value
      });

    }

    const moveOut = (<FormArray>self.productForm.get("moveoutdate")).at(index);

    if (index == 0) {
      moveOut.patchValue({
        moveoutdate: this.todaysDate
      });

    }


  }

}

@Component({
  selector: 'add-action',
  template: `
  <ion-content>
  <ion-header color="secondary">
    <ion-navbar>
      <ion-buttons right>
        <button ion-button icon-left (click)="dismiss()" >
          Close
        </button>
      </ion-buttons>
      <ion-title>
      Select Address
    </ion-title>
     </ion-navbar>
     </ion-header>
     <ion-list>
      <ion-item style="white-space:intial" *ngFor="let selected of address">
       <p (click)="selectedAddress(selected)"> {{selected.text}}</p>
      </ion-item>
     </ion-list>
  </ion-content>
  `
})
export class AddActionModal {
  address: any;
  constructor(
    public alertCtrl: AlertController,

    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public settingsProvider: SettingsProvider
  ) {
    this.address = this.navParams.get("address");
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  selectedAddress(data) {
    this.viewCtrl.dismiss(data);
  }






}


// WEBPACK FOOTER //
// ./src/pages/new-account/bank-new-account/application-address/application-address.ts